import { ErrorBoundary } from "@sentry/react";
import { createRootRouteWithContext, useMatches } from "@tanstack/react-router";
import { PropsWithChildren, Suspense } from "react";

import { RouterToast } from "@/components/router/toast";
import { RouterContext } from "@/router";

import { Layout } from "../components/layout";
import { LoadingScreen, SuspenseLoadingScreen } from "../components/loading-screen";
import { NavigationLoadingProvider } from "../providers/general/navigation-loading-provider";
import { ProtectedRoute } from "../providers/hooks/use-protected-route";
import { NotFoundPage as notFoundComponent } from "./not-found/-index";

export const Route = createRootRouteWithContext<RouterContext>()({
    component: Root,
    notFoundComponent,
});

function ProtectedRouteWrapper({ children }: PropsWithChildren) {
    const matches = useMatches();
    const currentMatch = matches[matches.length - 1];

    const permissions = currentMatch?.staticData?.permissions || [];

    return <ProtectedRoute permissions={permissions}>{children}</ProtectedRoute>;
}

export function Root() {
    return (
        <ErrorBoundary>
            <ProtectedRouteWrapper>
                <NavigationLoadingProvider>
                    <LoadingScreen />
                    <Suspense fallback={<SuspenseLoadingScreen />}>
                        <Layout />
                    </Suspense>
                </NavigationLoadingProvider>
            </ProtectedRouteWrapper>

            <RouterToast />
        </ErrorBoundary>
    );
}
